import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { SettingsService } from '../services/settings-service';
import { UserService } from '../services/user-service';
import { isAdminGroup } from '../models/user.model';

export const featureFlagGuard: CanActivateFn = (route) => {
  const settingsService = inject(SettingsService);
  const userService = inject(UserService);
  const router = inject(Router);

  const featureName: string | undefined = route.data['featureName'];
  const requiresAdmin: boolean = route.data['requiresAdmin'] ?? false;

  return settingsService.loadAllSettings().pipe(
    switchMap(settings =>
      userService.getUser().pipe(
        take(1),
        map(user => [settings, user] as const)
      )
    ),
    map(([settings, user]) => {
      if (!settings || !user) {
        return router.createUrlTree(['/overview']);
      }

      const isUserAdmin = isAdminGroup(user.group);

      const featureSetting = settings.find(
        (s) => s.featureName?.toLowerCase() === featureName?.toLowerCase()
      );
      const isFeatureEnabled = featureSetting?.isEnabled ?? false;

      if (!isFeatureEnabled) {
        return router.createUrlTree(['/overview']);
      }

      if (requiresAdmin && !isUserAdmin) {
        return router.createUrlTree(['/overview']);
      }

      return true;
    }),
    catchError(() => of(router.createUrlTree(['/overview'])))
  );
};
